<div class="dialog-container">
  <!-- HEADER -->
  <div class="dialog-header">
    {{ data.title }}
    <button class="btn-x" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <ng-container *ngIf="dialogState === 'confirm'">
      <p class="message" style="white-space: pre-line">
        {{ data.message }}
      </p>
    </ng-container>

    <ng-container *ngIf="dialogState === 'error'">
      <p class="error">
        {{ errorMessage }}
      </p>
    </ng-container>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <ng-container *ngIf="dialogState === 'confirm'">
      <button class="yes-btn save-btn" (click)="onConfirm()" [disabled]="submitting">
        <span *ngIf="!submitting">{{ data.confirmText || 'Yes' }}</span>

        <mat-progress-spinner
          *ngIf="submitting"
          diameter="18"
          class="spinner-overlay"
          mode="indeterminate"
        ></mat-progress-spinner>
      </button>

      <button class="no-btn" (click)="onCancel()" [disabled]="submitting">{{ data.cancelText || 'No' }}</button>
    </ng-container>

    <ng-container *ngIf="dialogState === 'error'">
      <button class="yes-btn" (click)="onConfirm()" [disabled]="submitting">Retry</button>

      <button class="no-btn" (click)="onCancel()">Close</button>
    </ng-container>
  </mat-dialog-actions>
</div>
